export default "__VITE_ASSET__ea4573ff__"